import { render, staticRenderFns } from "./RsImageComponent.vue?vue&type=template&id=54d5a150&scoped=true&"
import script from "./RsImageComponent.vue?vue&type=script&lang=js&"
export * from "./RsImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./RsImageComponent.vue?vue&type=style&index=0&id=54d5a150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5a150",
  null
  
)

export default component.exports